import { HttpErrorResponse } from '@angular/common/http';

interface ApiErrorsItem {
  code: string;
  description: string;
  type: string;
}

export function httpErrorResponseToText(err: HttpErrorResponse): string {
  // If the err is text, just return that
  if (typeof err === 'string') {
    return err;
  }

  // If it's an Error Event, return the message
  if (err?.error instanceof ErrorEvent) {
    return err.error.message;
  }

  if (err?.error?.detail) {
    return err?.error?.detail;
  }

  if (typeof err?.error === 'string') {
    // If the error is a string, then return that
    return err.error;
  }

  let msg = '';

  // Get all the errors from an error collection
  if (err?.error?.errors) {
    if (Array.isArray(err?.error?.errors)) {
      const errors = err?.error?.errors as Array<ApiErrorsItem>;

      msg = errors.map((error) => error.description).join('<br >');
    } else {
      for (const key of Object.keys(err?.error?.errors)) {
        const value = err?.error?.errors[key];
        if (Array.isArray(value)) {
          value.forEach(function (item) {
            msg = `${msg} ${item ?? key},`;
          });
        }
      }
    }
  }

  // If no error was found, then return a standard message.
  if (msg === '') {
    msg = 'Unexpected error. Please try again';
  }

  return msg;
}
